import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {Component} from 'vue-property-decorator';
import {AdminDataFieldService, JobService} from '../../../shared/services';

@Component
export default class JobStatusComponent extends VueWrapper {
    public jobsSrv: JobService = new JobService();
    public adminDataFieldSrv: AdminDataFieldService = new AdminDataFieldService();
}
